import { ReactNode } from "react";
import styles from "./dropshadow.module.scss";
import { ArrowRightIcon } from "@/frontend/shared/assets/icons/ArrowRightIcon";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { Typography } from "@/frontend/shared/ui/Typography";
import { ArrowSquareInIcon, TrashIcon } from "@/frontend/shared/assets/icons";
import { ArchiveIcon } from "@/frontend/shared/assets/icons/ArchiveIcon";

export function buildPipelineDropshadowOptions(
  availableStages: { label: string; value: string }[],
  currentStage: string,
  onMoveRightClick: (v: string) => void,
  onMoveClick: () => void,
  onArchiveClick: () => void,
  onRemoveClick: () => void
) {
  // TODO: finish
  const options: ReactNode[] = [];
  const currentIndex = availableStages?.map((stage) => stage.label).indexOf(currentStage);

  if (currentIndex != availableStages?.length - 1) {
    const nextStage = availableStages[currentIndex + 1];
    options.push(
      <div className={styles.option}>
        <NormalButton
          className={styles.moveForward}
          size="medium"
          color="greyscale900"
          variant="tertiary"
          onClick={() => onMoveRightClick(nextStage.value)}
        >
          <ArrowRightIcon />
          <Typography variant="label-4" color="greyscale900">
            Move to
          </Typography>
          <Typography variant="label-4" color="greyscale600">
            {nextStage.label}
          </Typography>
        </NormalButton>
      </div>
    );
  }
  options.push(
    <div className={styles.option}>
      <NormalButton
        className={styles.moveSomewhere}
        size="medium"
        color="greyscale900"
        variant="tertiary"
        onClick={onMoveClick}
      >
        <ArrowSquareInIcon />
        <Typography variant="label-4" color="greyscale900">
          Move
        </Typography>
      </NormalButton>
    </div>
  );
  options.push(
    <div className={styles.option}>
      <NormalButton
        className={styles.archive}
        size="medium"
        color="greyscale900"
        variant="tertiary"
        onClick={onArchiveClick}
      >
        <ArchiveIcon />
        <Typography variant="label-4" color="greyscale900">
          Archive
        </Typography>
      </NormalButton>
    </div>
  );
  options.push(
    <div className={styles.option}>
      <NormalButton
        className={styles.remove}
        size="medium"
        color="greyscale900"
        variant="tertiary"
        onClick={onRemoveClick}
      >
        <TrashIcon />
        <Typography variant="label-4" color="greyscale900">
          Remove
        </Typography>
      </NormalButton>
    </div>
  );

  return options;
}
